import React from 'react';
import './App.css';
import Home from './components/pages/Home'
import Projects from './components/pages/Projects'
import AboutMe from './components/pages/AboutMe'
import NavBar from './components/NavBar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorPage from './components/pages/ErrorPage';

function App() {
  return (
    <>
    <Router>
      <NavBar />
      <Routes>
        <Route path='/' exact element={<Home/>} />  
        <Route path='/projects' element={<Projects/>} />
        <Route path='/about-me' element={<AboutMe/>} />
        <Route path='/error-page' element={<ErrorPage/>} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
